'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessfulModal = undefined;

var _SuccessfulModal2 = require('./SuccessfulModal');

var _SuccessfulModal3 = _interopRequireDefault(_SuccessfulModal2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SuccessfulModal = _SuccessfulModal3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/SuccessfulModal/index.js
// module id = 1794
// module chunks = 0